import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { RequireAuth } from './components/layout/RequireAuth';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { AuthLayout } from './components/layout/AuthLayout';

// Pages
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { StoreProfilePage } from './pages/store/StoreProfilePage';
import { SettingsPage } from './pages/settings/SettingsPage';
import { CreateDealPage } from './pages/deals/CreateDealPage';
import { ActiveDealsPage } from './pages/deals/ActiveDealsPage';
import { DealHistoryPage } from './pages/deals/DealHistoryPage';
import { ScheduledDealsPage } from './pages/deals/ScheduledDealsPage';
import { ScannerSetupPage } from './pages/scanner/ScannerSetupPage';
import { DealAnalyticsPage } from './pages/analytics/DealAnalyticsPage';
import { StoreAnalyticsPage } from './pages/analytics/StoreAnalyticsPage';

function App() {
  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Route>

        {/* Protected routes */}
        <Route
          element={
            <RequireAuth>
              <DashboardLayout />
            </RequireAuth>
          }
        >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/deals/create" element={<CreateDealPage />} />
          <Route path="/deals/active" element={<ActiveDealsPage />} />
          <Route path="/deals/history" element={<DealHistoryPage />} />
          <Route path="/deals/scheduled" element={<ScheduledDealsPage />} />
          <Route path="/scanner/setup" element={<ScannerSetupPage />} />
          <Route path="/analytics" element={<DealAnalyticsPage />} />
          <Route path="/analytics/store" element={<StoreAnalyticsPage />} />
          <Route path="/store" element={<StoreProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
